import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getAccountInfo } from "./../../store/actions/accounts-actions";
import BillingInfo from "../claims/components/billing-info/BillingInfo";
import PetParentInfo from "../view-profile/components/PetParentInfo";

import UpdateSuccessView from "../common/update-success-view/UpdateSuccessView";
import LiveChat from "../common/live-chat/LiveChat.js";
import { contactInformation , ContactForm } from "../reinstatement/reinstate.view.component";

import "../contact/contact.css"; 

class ReinstatementPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contactFormFieldApi: undefined,
      showThankYouPage: false
    };

    window.dataLayer.push({
      event: "Pageview",
      url: window.location.pathname
    });
  }

  _isMounted = false;

  componentDidMount() {
  this._isMounted = true;

  if (this.props.actions && this.props.actions.getAccountInfo) {
    this.props.actions.getAccountInfo();
  }

  window.scrollTo(0, 0);
  }


  componentWillUnmount() {
    this._isMounted = false;
  }


  setShowThankYouPage = () => {
    window.dataLayer.push({
      event: "Pageview",
      url: window.location.pathname + "/Confirm"
    });

    this.setState({ showThankYouPage: true });
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (
      prevState.contactFormFieldApi &&
      nextProps.userAccountDetails &&
      nextProps.userAccountDetails !== prevState.userAccountDetails
    ) {
      const { PetParentInfo } = nextProps.userAccountDetails;

      prevState.contactFormFieldApi.setValue("email", PetParentInfo.Email);
      prevState.contactFormFieldApi.setValue(
        "name",
        `${PetParentInfo.FirstName} ${PetParentInfo.LastName}`
      );
      prevState.contactFormFieldApi.setValue(
        "primaryPhoneNumber",
        PetParentInfo.PrimaryPhone
      );
    }
    return null;
  }

  setContactFormFieldAPI = api => {
    this.setState({ contactFormFieldApi: api });
  };

  render() {
    const { showThankYouPage } = this.state;
    const { userAccountDetails, userAccountDetailsFetching } = this.props;

    return (
      <React.Fragment>
        {showThankYouPage ? (
          <UpdateSuccessView
            statusHeader="Your submission was successful."
            title="Thank you!"
          >
            <div>
              We'have received your message and will respond to you as soon as we
              can.
            </div>
            <button
              className="button-secondary home-button-thank-you"
              type="submit"
              onClick={() => this.props.history.push("/")}
            >
              Home
            </button>
            {contactInformation()}
          </UpdateSuccessView>
        ) : (
          <div className="container contact-container">
            <h1 className="d-flex align-items-center title">Contact Customer Care</h1>
            <div className="row">
              <div className="col-12 col-lg-8 container-view position-static">
                <ContactForm
                  setContactFormFieldAPI={this.setContactFormFieldAPI}
                  showDropDown={true}
                  setShowContactThankYouPage={this.setShowThankYouPage}
                  fetching={userAccountDetailsFetching}
                />
              </div>
              {this.rightColumn(userAccountDetails)}
            </div>
            <LiveChat userAccountDetails={userAccountDetails} />
          </div>
        )}
      </React.Fragment>
    );
  }

rightColumn = userAccountDetails => {
    return (
      <div className="rightColumn d-none d-lg-block col-lg-4 ">
        {userAccountDetails &&
          userAccountDetails.PetParentInfo &&
          userAccountDetails.PhysicalAddress &&
          userAccountDetails.MailingAddress && (
            <React.Fragment>
              <BillingInfo
                creditCard={userAccountDetails.Last4CreditCard}
                billingInfo={userAccountDetails.BillingAddress}
                status={userAccountDetails.Status}
                billingDay={userAccountDetails.BillingDay}
                premium={userAccountDetails.MonthlyPremium}
                newMonthlyPremium={userAccountDetails.NewMonthlyPremium}
                changeEffectiveDate={userAccountDetails.ChangeEffectiveDate}
              />

              <div className="billing-info mt-4">
                <div className="info-header text-primary">
                  Contact Information
                </div>
                <div className="info-body info-body-padding d-flex flex-column justify-content-between">
                  <PetParentInfo
                    parentInfo={userAccountDetails.PetParentInfo}
                    address={userAccountDetails.PhysicalAddress}
                    mailingAddress={userAccountDetails.MailingAddress}
                    hidePassword={true}
                    policyEffectiveDate={userAccountDetails.PolicyEffectiveDate}
                    status={userAccountDetails.Status}
                  />
                </div>
                <div className="info-footer" />
              </div>
            </React.Fragment>
          )}
      </div>
    );
  };
}

const mapStateToProps = state => ({
  userAccountDetails: state.account.userAccountDetails,
  userAccountDetailsFetching: state.account.fetching
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ getAccountInfo }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ReinstatementPage);
